/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid, formatValue } from '../common';
import { checkIfObjectHasAnyData } from 'utils/general';

const fieldsToIgnore = ['areas', 'income', 'other1', 'others'];

export const getCompilationOfAreasData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.COMPILATION_OF_AREAS;

  const compilationAreasData = dataSet[factKey];

  const CompilationAreaFactsRow = ({ facts }) => {
    const areaFields = ['area'];
    const krFields = [
      'rentIncomes',
      'otherIncomes',
      'operatingCosts',
      'otherIncome',
      'rentalIncome',
      'flatOperatingCost',
      'pricePerSquareMeter',
      'otherIncomePerSquareMeter',
      'flatOperatingCostSquareMeter'
    ];

    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {formatValue({
              facts,
              krFields
            })}{' '}
            <Unit areaFields={areaFields} krFields={krFields} facts={facts} />
          </div>
        </div>
      );
    }

    return <></>;
  };

  let fields = [];

  Object.keys(compilationAreasData).forEach((fieldKey, index) => {
    if (
      !fieldsToIgnore.includes(fieldKey) &&
      checkIfValueIsValid(compilationAreasData[fieldKey])
    ) {
      fields.push(
        <CompilationAreaFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: compilationAreasData[fieldKey]
          }}
        />
      );
    }
  });

  const OtherDataSection = () => {
    return (
      <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
        <div className='object-listing-accordian-list-left'>
          {objectText?.compilationAreas?.other?.label}
        </div>
        <div className='object-listing-accordian-list-right'></div>
        <div className='other-info'>
          {checkIfObjectHasAnyData(compilationAreasData?.other1) &&
            Object.keys(compilationAreasData?.other1).map(
              (optionKey, optionIndex) => {
                return (
                  <CompilationAreaFactsRow
                    key={optionIndex}
                    facts={{
                      factFieldName: optionKey,
                      value: compilationAreasData?.other1[optionKey]
                    }}
                  />
                );
              }
            )}
        </div>
      </div>
    );
  };

  const AreasDataSection = () => {
    if (
      checkIfValueIsValid(compilationAreasData?.areas?.comment) ||
      checkIfValueIsValid(compilationAreasData?.areas?.description)
    ) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.compilationAreas?.area?.label}
          </div>
          <div className='object-listing-accordian-list-right'></div>
          <div className='areas-info'>
            <CompilationAreaFactsRow
              key='areas0'
              facts={{
                factFieldName: 'comment',
                value: compilationAreasData?.areas?.comment
              }}
            />
            <CompilationAreaFactsRow
              key='areas1'
              facts={{
                factFieldName: 'description',
                value: compilationAreasData?.areas?.description
              }}
            />
          </div>
        </div>
      );
    }

    return <></>;
  };

  const IncomeDataSection = () => {
    if (
      checkIfValueIsValid(compilationAreasData?.income?.comment) ||
      checkIfValueIsValid(compilationAreasData?.income?.description)
    ) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.compilationAreas?.income?.label}
          </div>
          <div className='object-listing-accordian-list-right'></div>
          <div className='income-info'>
            <CompilationAreaFactsRow
              key='income0'
              facts={{
                factFieldName: 'comment',
                value: compilationAreasData?.income?.comment
              }}
            />
            <CompilationAreaFactsRow
              key='income1'
              facts={{
                factFieldName: 'description',
                value: compilationAreasData?.income?.description
              }}
            />
          </div>
        </div>
      );
    }

    return <></>;
  };

  const CompilationAreaSection = () => {
    return (
      <div className='compilation-areas-data-body'>
        {fields}
        <OtherDataSection />
        <AreasDataSection />
        <IncomeDataSection />
      </div>
    );
  };

  return {
    component: <CompilationAreaSection />,
    factsCount: fields.length
  };
};
